import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { APP_LOGO, APP_NAME, ROUTES } from '../../config/constants';
import { MainNav } from '../AppNav/NavItems';

class Sidebar extends Component {
  isActive = (item, location) => {
    if (item.exact) {
      return location.pathname === item.to;
    }
    if (item.matchPrefix) {
      return location.pathname.startsWith(item.matchPrefix);
    }
    return location.pathname === item.to || location.pathname.startsWith(`${item.to}/`);
  };

  render() {
    const { location, onToggleMobile } = this.props;

    return (
      <div className="nk-sidebar is-dark nk-sidebar-fixed iaept-sidebar" data-content="sidebarMenu">
        <div className="iaept-sidebar-head">
          <NavLink to={ROUTES.DASHBOARD} className="iaept-sidebar-logo-link">
            <img className="iaept-sidebar-logo" src={APP_LOGO} alt={APP_NAME} />
          </NavLink>
          <button
            type="button"
            className="iaept-sidebar-close d-xl-none"
            onClick={onToggleMobile}
            aria-label="Close sidebar"
          >
            <em className="icon ni ni-arrow-left" />
          </button>
        </div>

        <div className="iaept-sidebar-scroll">
          <div className="iaept-sidebar-portal-item">
            <div className="iaept-portal-box">
              <div className="iaept-portal-icon">
                <em className="icon ni ni-globe" />
              </div>
              <div className="iaept-portal-text">
                <span className="iaept-portal-title">Indgigs</span>
                <span className="iaept-portal-subtitle">Arbitrator Portal</span>
              </div>
            </div>
          </div>

          <ul className="nk-menu iaept-sidebar-menu">
            {MainNav.map((item) => (
              <li
                key={item.label}
                className={`nk-menu-item${this.isActive(item, location) ? ' active current-page' : ''}`}
              >
                <NavLink
                  to={item.to}
                  className="nk-menu-link"
                  isActive={() => this.isActive(item, location)}
                >
                  <span className="nk-menu-icon">
                    <em className={`icon ni ${item.icon}`} />
                  </span>
                  <span className="nk-menu-text">{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default withRouter(Sidebar);
